(() => {
  const init = () => {
    document.querySelectorAll('[data-aab-page]').forEach((page) => {
      const filters = [...page.querySelectorAll('[data-aab-filter]')];
      const cards = [...page.querySelectorAll('[data-aab-path]')];

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.aabFilter;
          filters.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          cards.forEach((card) => {
            card.hidden = value !== 'all' && card.dataset.aabPath !== value;
          });
        });
      });

      const partnerChecks = [...page.querySelectorAll('[data-aab-readiness]')];
      const partnerCount = page.querySelector('[data-aab-readiness-count]');
      const updateReadiness = () => {
        if (!partnerCount) return;
        const checked = partnerChecks.filter((item) => item.checked).length;
        partnerCount.textContent = String(checked);
      };
      partnerChecks.forEach((item) => item.addEventListener('change', updateReadiness));
      updateReadiness();

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        page.querySelectorAll('.aab-reveal').forEach((item) => observer.observe(item));
      } else {
        page.querySelectorAll('.aab-reveal').forEach((item) => item.classList.add('is-visible'));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
